import Skeleton from "react-loading-skeleton";

const AfterServiceSkeleton = () => {
  return (
    <>
      {[...Array(2)].map((_, index) => (
        <>
          <div className="py-7" key={index}>
            <div className="mb-2.5">
              <Skeleton width="50%" height="1.75rem" />
            </div>
            <div className="mb-5">
              <Skeleton width="30%" height="1.75rem" borderRadius="20px" />
            </div>
            <Skeleton width="70%" height="1.75rem" />
            <Skeleton width="100%" height="1.75rem" />
            <Skeleton width="40%" height="1.75rem" />
            <Skeleton width="60%" height="1.75rem" />
          </div>
          <Skeleton width="100%" height="1px" />
        </>
      ))}
    </>
  );
};

export default AfterServiceSkeleton;
